<template>
    <div>
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="whiteBG p-3 education-Section mb-4">
            <section class="blockElement mainBanner">
                <div class="inner-banner-custom row align-items-center">
                    <div class="col-12 text-center">
                        <h2 class="mb-3"> {{$t('web_webinars')}}</h2>
                        <p>{{$t('web_enhancetrad')}}</p>
                    </div>
                </div>
            </section>
             <!--Section-->
            <!-- <section class="blockElement">
                <h2 class="mb-3 mt-4 text-center">{{$t('web_registeran')}} <span>{{$t('web_upcomingweb')}}</span></h2>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-8">
                        <div class="row" v-for="list in web_data">
                            <div class="col-12"> 
                                <div  class="webinarBlock">
                                    <div class="d-flex align-items-start justify-content-between w-100">
                                        <div class="weinarHead">
                                            <h6 class="mb-0">{{list.title || '-'}}</h6>
                                            <p class="sm date">{{formatTime(list.created)}}</p>
                                        </div>
                                        <div class="weinarHead">
                                            <a data-toggle="modal" data-target="#exampleModal" href="#" class="prism_btn">{{$t('web_register')}}</a>
                                        </div>
                                    </div>
                                    <div class="countdown-wrap">
                                        <p>{{$t('web_timeleft')}}</p>
                                        <div id="clockdiv">
                                            <span class="time-label"><span class="days-label">0</span> {{$t('web_days')}}</span>
                                            <span class="time-label"><span class="days-label">16</span> {{$t('web_hours')}}</span>
                                            <span class="time-label"><span class="days-label">48</span> {{$t('web_mins')}}</span>
                                            <span class="time-label"><span class="days-label">34</span> {{$t('web_secs')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="noRecordFound" v-if="web_data.length == 0 && !pageLoader"> 
                            <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                            <p>{{$t('edu_thereIsNoRecord')}}</p>
                        </div>
                    </div>
                </div>
            </section> -->
            <section class="blockElement doticonHover right position-relative videroTab-tutorial between-footer">
                <h2 class="mb-4 mt-4 text-center">{{$t('web_webnar')}}  <span>{{$t('web_library')}}</span></h2>
                <div class="row m-0 mainContent-webinar">
                    <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                            <div class="mainContentArea position-relative"  > 
                                <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-2.jpg" alt="Generic image"> -->
                                <div class="mainContent-img">
                                    <div class="logoVideo"><img width="135px" src="../../../../../static/fxView/images/white-logo.svg" alt="" /> </div>
                                    <a href="#"  class="playInc" v-on:click.prevent="clickFunc($env_var.webinarLink7)"><feather type="play-circle"></feather> </a>
                                   <!--  <p class="inntBotm">{{list.title}}</p> -->
                                </div>
                            </div>
                          <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-2.jpg" alt="Generic image" v-on:click.prevent="clickFunc('2')"> -->
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('web_findright')}}<span class="d-block">(9th August 2021)</span></a>
                          </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                            <div class=" mainContentArea position-relative"  > 
                                <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-3.jpg" alt="Generic image"> -->
                                <div class="mainContent-img" >
                                    <div class="logoVideo"><img width="135px" src="../../../../../static/fxView/images/white-logo.svg" alt="" /> </div>
                                    <a href="#"  class="playInc" v-on:click.prevent="clickFunc($env_var.webinarLink8)"><feather type="play-circle"></feather> </a>
                                   <!--  <p class="inntBotm">{{list.title}}</p> -->
                                </div>
                            </div>
                         <!--  <img class="mr-3" src="../../../../../static/fxView/images/image-3.jpg" alt="Generic image" v-on:click.prevent="clickFunc('3')"> -->
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('web_weekahead')}} <span class="d-block">(11th August 2021)</span></a>
                          </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                            <div class="mainContentArea position-relative"  > 
                                <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-1.jpg" alt="Generic image"> -->
                                <div class="mainContent-img">
                                    <div class="logoVideo"><img width="135px" src="../../../../../static/fxView/images/white-logo.svg" alt="" /> </div>
                                    <a href="#"  class="playInc" v-on:click.prevent="clickFunc($env_var.webinarLink6)"><feather type="play-circle"></feather> </a>
                                   <!--  <p class="inntBotm">{{list.title}}</p> -->
                                </div>
                            </div>
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('web_higherpower')}} <span class="d-block">(13th August 2021)</span></a>
                          </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                            <div class="mainContentArea position-relative"  > 
                                <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-1.jpg" alt="Generic image"> -->
                                <div class="mainContent-img">
                                    <div class="logoVideo"><img width="135px" src="../../../../../static/fxView/images/white-logo.svg" alt="" /> </div>
                                    <a href="#"  class="playInc" v-on:click.prevent="clickFunc($env_var.webinarLink1)"><feather type="play-circle"></feather> </a>
                                   <!--  <p class="inntBotm">{{list.title}}</p> -->
                                </div>
                            </div>
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('fxEngulfingCandlesWebinar')}} <span class="d-block">(28th August)</span></a>
                          </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                            <div class="mainContentArea position-relative"  > 
                                <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-2.jpg" alt="Generic image"> -->
                                <div class="mainContent-img">
                                    <div class="logoVideo"><img width="135px" src="../../../../../static/fxView/images/white-logo.svg" alt="" /> </div>
                                    <a href="#"  class="playInc" v-on:click.prevent="clickFunc($env_var.webinarLink2)"><feather type="play-circle"></feather> </a>
                                   <!--  <p class="inntBotm">{{list.title}}</p> -->
                                </div>
                            </div>
                          <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-2.jpg" alt="Generic image" v-on:click.prevent="clickFunc('2')"> -->
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('fxDOJICandlesWebinar')}}<span class="d-block">(14th September)</span></a>
                          </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                            <div class=" mainContentArea position-relative"  > 
                                <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-3.jpg" alt="Generic image"> -->
                                <div class="mainContent-img" >
                                    <div class="logoVideo"><img width="135px" src="../../../../../static/fxView/images/white-logo.svg" alt="" /> </div>
                                    <a href="#"  class="playInc" v-on:click.prevent="clickFunc($env_var.webinarLink3)"><feather type="play-circle"></feather> </a>
                                   <!--  <p class="inntBotm">{{list.title}}</p> -->
                                </div>
                            </div>
                         <!--  <img class="mr-3" src="../../../../../static/fxView/images/image-3.jpg" alt="Generic image" v-on:click.prevent="clickFunc('3')"> -->
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('fxHaramiCandlesWebinar')}}  <span class="d-block">(30th September)</span></a>
                          </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                            <div class=" mainContentArea position-relative"> 
                                <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-3.jpg" alt="Generic image"> -->
                                <div class="mainContent-img" >
                                    <div class="logoVideo"><img width="135px" src="../../../../../static/fxView/images/white-logo.svg" alt="" /> </div>
                                    <a href="#"  class="playInc" v-on:click.prevent="clickFunc($env_var.webinarLink4)"><feather type="play-circle"></feather> </a>
                                   <!--  <p class="inntBotm">{{list.title}}</p> -->
                                </div>
                            </div>
                         <!--  <img class="mr-3" src="../../../../../static/fxView/images/image-3.jpg" alt="Generic image" v-on:click.prevent="clickFunc('3')"> -->
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('fxHammerCandlesWebinar')}}  <span class="d-block">(7th October)</span></a>
                          </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                            <div class=" mainContentArea position-relative"  > 
                                <!-- <img class="mr-3" src="../../../../../static/fxView/images/image-3.jpg" alt="Generic image"> -->
                                <div class="mainContent-img" >
                                    <div class="logoVideo"><img width="135px" src="../../../../../static/fxView/images/white-logo.svg" alt="" /> </div>
                                    <a href="#"  class="playInc" v-on:click.prevent="clickFunc($env_var.webinarLink5)"><feather type="play-circle"></feather> </a>
                                   <!--  <p class="inntBotm">{{list.title}}</p> -->
                                </div>
                            </div>
                         <!--  <img class="mr-3" src="../../../../../static/fxView/images/image-3.jpg" alt="Generic image" v-on:click.prevent="clickFunc('3')"> -->
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('fxStarFormations')}}  <span class="d-block">(22nd October)</span></a>
                          </div>
                        </div>
                    </div>
                    <!-- <div class="col-12 col-lg-6"> 
                        <div class="media weinarMedia">
                          <img class="mr-3" src="../../../../../static/fxView/images/image-4.jpg" alt="Generic image">
                          <div class="media-body">
                            <a href="#" class="mt-0">{{$t('web_introTrend')}}<span class="d-block">{{$t('web_apreighteen')}}</span></a>
                          </div>
                        </div>
                    </div> -->
                </div>
            </section>
        </div>
       <!--------OPEN MODAL---------------->
       <div class="modal fade webinatPopup" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header border-0">
                <h5 class="modal-title" id="exampleModalLabel">
                    <!-- <img class="bull" src="../../../../../static/fxView/images/fxview_logo.svg" alt="Banner"> -->
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="headTitle-pop px-3 text-center">
                <h6 class="mb-0">{{$t('web_topicdiscuss')}}</h6>
                <p>{{$t('web_correlation')}}</p>
              </div>
              <div class="modal-body p-0">
                <div class="meDate  px-4">
                   <p class="mb-1">{{$t('web_datemay')}}</p> 
                   <h3 class="green">{{$t('web_showlocal')}}</h3>
                </div>
                   <div class="mainContent-wrap  px-4">
                    <p>{{$t('web_joinfxview')}}</p>
                    <p>{{$t('web_secureplace')}}</p>

                    <h3>{{$t('web_topicsCovered')}}</h3>
                    <ul>
                        <li>{{$t('web_strongweak')}}</li>
                        <li>{{$t('web_corrmultiple')}}</li>
                        <li>{{$t('web_posneg')}}</li>
                    </ul>
                   </div>
                   <div class="formWrap  px-4">
                        <div class="stepForm-contact mt-5">
                    <div class="row"> 
                        <div class="text-left col-12"></div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input placeholder="First Name" type="text" name="username" class="float-field pt-0">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input placeholder="Last Name" type="text" name="username" class="float-field pt-0">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input placeholder="Email address" type="email" name="username" class="float-field pt-0">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input placeholder="Phone Number" type="text" name="username" class="float-field pt-0">
                            </div>
                        </div>
                        
                        <div class="col-12 col-md-12 mt-3">
                            <div class="form-group field-wrapper text-center">
                                <button class="prism_btn">{{$t('web_register')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                   </div>
              </div>
            </div>
          </div>
        </div>


    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'Video Tutorials',
        data() {
            return {
                showData : 'zero',
                pageLoader : false,
                web_data : [],
                msg_type : '',
                response_msg : '',
            }
        },
        methods:{
            formatTime(date){
                return moment(date).format('L h:mm a')
            },
            tabFunc(getData){
                this.showData = getData
            },
            clickFunc(getUrl){
                window.open(getUrl)
            },
            listing(){
                let inputJson = {
                    'globalParams' : {},
                    'localParams' : {'parameter' : this}
                }
                //this._runGetWebinarData(inputJson)
            }
         
        },
        created(){
            this.listing()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/research/pages/webinar_fxview.vue